/**
 * Email Popup
 * 
 * Shows a popup after a specified delay for collecting email addresses
 * Uses localStorage to avoid showing the popup to returning visitors
 */

class EmailPopup {
  constructor() {
    this.popupElement = document.getElementById('email-popup');
    if (!this.popupElement) return;
    
    this.closeButton = this.popupElement.querySelector('.popup-close-button');
    this.form = this.popupElement.querySelector('form');
    this.cookieName = 'email_popup_shown';
    this.popupDelay = 5000; // Default 5 seconds
    
    this.init();
  }
  
  init() {
    // Only show popup if it hasn't been shown before
    if (!this.hasPopupBeenShown()) {
      this.setShowTimeout();
      this.setupEventListeners();
    }
  }
  
  setShowTimeout() {
    setTimeout(() => {
      this.showPopup();
    }, this.popupDelay);
  }
  
  showPopup() {
    if (!this.popupElement) return;
    
    this.popupElement.style.display = 'flex';
    // Use setTimeout to ensure display: flex is applied before adding the active class
    setTimeout(() => {
      this.popupElement.classList.add('active');
    }, 10);
    
    this.markPopupAsShown();
  }
  
  hidePopup() {
    if (!this.popupElement) return;
    
    this.popupElement.classList.remove('active');
    
    // Wait for the transition to complete before hiding
    setTimeout(() => {
      this.popupElement.style.display = 'none';
    }, 300);
  }
  
  setupEventListeners() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.hidePopup.bind(this));
    }
    
    // Close popup when clicking outside the popup content
    this.popupElement.addEventListener('click', (event) => {
      if (event.target === this.popupElement) {
        this.hidePopup();
      }
    });
    
    // Close popup when ESC key is pressed
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.hidePopup();
      }
    });
    
    // Handle form submission
    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        if (event.target.querySelector('.form-status-success')) {
          setTimeout(() => {
            this.hidePopup();
          }, 3000);
        }
      });
    }
  }
  
  hasPopupBeenShown() {
    return localStorage.getItem(this.cookieName) === 'true';
  }
  
  markPopupAsShown() {
    localStorage.setItem(this.cookieName, 'true');
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  const emailPopup = new EmailPopup();
}); 